import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  root: {
    display: 'flex',
    flexShrink: 0,
    lineHeight: 0,
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    boxSizing: 'border-box',
    overflow: 'hidden',
    lineHeight: 0,

    '& .MuiCircularProgress-root': {
      flexShrink: 0,
    },
  },
}));
